import { useOrganizationCloudRenderingPolicies } from "./useOrganizationCloudRenderingPolicies";

export function useFixedIpPolicyQuery() {
  return useOrganizationCloudRenderingPolicies({
    select: (data) => data.virtualMachinesRequireFixedIpPolicy ?? false,
  });
}
